import request from 'tools/request'
import {
  GpsMilesData,
  HeartbeatVehicle,
  VehicleActiveData,
  VehiclePolicyGraphicsData,
} from 'interfaces/ICarrierHeartbeat'

const getHeartbeatVehicles = async (
  carrierId: number,
  active: number
): Promise<HeartbeatVehicle[]> => {
  const response = await request.get<HeartbeatVehicle[]>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/carrier-heartbeat/vehicles`,
    {
      params: {
        carrierId,
        active,
      },
    }
  )
  return response.data
}

const getVehiclePolicyGraphicsData = async (
  carrierId: number
): Promise<VehiclePolicyGraphicsData> => {
  const response = await request.get<VehiclePolicyGraphicsData>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/carrier-heartbeat/vehicles-policy-graphics`,
    {
      params: {
        carrierId,
      },
    }
  )
  return response.data
}

const getVehicleActiveData = async (carrierId: number): Promise<VehicleActiveData> => {
  const response = await request.get<VehicleActiveData>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/carrier-heartbeat/vehicles-active`,
    {
      params: {
        carrierId,
      },
    }
  )
  return response.data
}

const getGpsMilesData = async (carrierId: number): Promise<GpsMilesData> => {
  const response = await request.get<GpsMilesData>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/carrier-heartbeat/vehicles-miles`,
    {
      params: {
        carrierId,
      },
    }
  )
  return response.data
}

const uploadVehiclePolicyCsv = async (carrierId: number, file: File) => {
  const formData = new FormData()
  formData.append('csv', file)
  const response = await request.post(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/carrier-heartbeat/upload-csv?carrierId=${carrierId}`,
    formData
  )
  return response.data
}

const clearVehiclePolicy = async (carrierId: number, payload: any) => { 
    const response = await request.post(
      `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/carrier-heartbeat/clear-policy?carrierId=${carrierId}`,
      payload
    )
    return response.data
}

const addVehicleToPolicy = async (carrierId: number, payload: any) => {
  const response = await request.post(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/carrier-heartbeat/add-vehicle-policy?carrierId=${carrierId}`,
    payload
  )
  return response.data
}

const pauseVehicle = async (
  carrierId: number,
  payload: any
) => {
  const response = await request.put(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/carrier-heartbeat/toggle-vehicle-status?carrierId=${carrierId}`,
    payload
  )
  return response.data
}

export {
  getHeartbeatVehicles,
  getVehiclePolicyGraphicsData,
  getVehicleActiveData,
  getGpsMilesData,
  uploadVehiclePolicyCsv,
  clearVehiclePolicy,
  addVehicleToPolicy,
  pauseVehicle,
}